import { render, staticRenderFns } from "./PluginAppModal.vue?vue&type=template&id=e82abc86&scoped=true"
import script from "./PluginAppModal.vue?vue&type=script&lang=js"
export * from "./PluginAppModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82abc86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e82abc86')) {
      api.createRecord('e82abc86', component.options)
    } else {
      api.reload('e82abc86', component.options)
    }
    module.hot.accept("./PluginAppModal.vue?vue&type=template&id=e82abc86&scoped=true", function () {
      api.rerender('e82abc86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/PluginAppModal.vue"
export default component.exports